import React, { FC } from 'react';
import { TableOfContents } from '../../../interfaces/TableOfContents';
import Content from './Content';
import { StyledTile } from './Section.styles';

export interface SectionProps {
  tableOfContentsData: TableOfContents;
  tableOfContentName: string;
}

const Section: FC<SectionProps> = ({ tableOfContentsData, tableOfContentName }) => (
  <StyledTile titleAs="h2" isDivided={false}>
    <Content data={tableOfContentsData} tableOfContentName={tableOfContentName} />
  </StyledTile>
);

export default Section;
